export type LaborInstallationIdentityInput = {
  installationId?: unknown;
  siteId?: unknown;
  siteName?: unknown;
  workDescription?: unknown;
  installationCode?: unknown;
  address?: unknown;
  clientName?: unknown;
};

export type LaborInstallationIdentity = {
  primary: string;
  secondary: string | null;
};

/** Canonical site name first; legacy work/code/address fallbacks stay explicit. */
export function resolveLaborInstallationIdentity(
  input: LaborInstallationIdentityInput,
): LaborInstallationIdentity {
  const clean = (value: unknown) => typeof value === "string" && value.trim() ? value.trim() : null;
  const siteName = clean(input.siteName);
  const workDescription = clean(input.workDescription);
  const installationCode = clean(input.installationCode);
  const address = clean(input.address);
  const clientName = clean(input.clientName);
  const id = Number(input.installationId);
  const primary = siteName
    ?? workDescription
    ?? installationCode
    ?? address
    ?? (Number.isInteger(id) && id > 0 ? `Instalación #${id}` : "Sede no identificada");
  const secondary = [
    siteName && siteName !== primary ? `Sede: ${siteName}` : null,
    workDescription && workDescription !== primary ? `Obra: ${workDescription}` : null,
    installationCode ? `Código ${installationCode}` : null,
    address && address !== primary ? `Dirección: ${address}` : null,
    clientName ? `Cliente: ${clientName}` : null,
  ].filter(Boolean).join(" · ") || null;
  return { primary, secondary };
}
